import clsx from 'clsx'
import type { HTMLAttributes } from 'react'
import styles from './NotificationContainer.module.css'

export interface NotificationContainerProps extends HTMLAttributes<HTMLDivElement> {
	isClickable?: boolean
}

export default function NotificationContainer({
	isClickable = false,
	className,
	...props
}: NotificationContainerProps) {
	return (
		<div
			data-clickable-feedback={!!isClickable}
			className={clsx(styles.container, className)}
			{...props}
		/>
	)
}
